
import { Component, Vue, Inject } from "vue-property-decorator";
import DZModelPage from "@/model/DZModelPage";
import nyMessageToast from "@/utils/NYMessageToast";
import dzMsgBox from "@/utils/DZMessageBox";
import DZServiceWiki from "@/views/百科管理/service/DZServiceWiki";

@Component({
    components: {}
})
export default class Index extends Vue {

    $refs: any;

    table_height = 0;

    is_dialog_show = false;

    is_edit = false;

    m_page = new DZModelPage(10);

    s_wiki = new DZServiceWiki();

    search = "";

    created() {
        this.action_list_data()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    dialog_init(){

    }

    dialog_close(){
        this.is_dialog_show = false
        this.dialog_init()
    }

    action_list_data(){
        this.s_wiki.net_page_label(this.m_page)
    }

    action_open_dialog(){
        this.is_edit = false
        this.is_dialog_show = true
    }

    action_add_label(){
        this.s_wiki.net_add_label(this.action_list_data)
        this.dialog_close()
    }

    handle_edit(row){
        this.is_edit = true
        this.s_wiki.m_label = Object.assign({},row)
        this.is_dialog_show = true
    }

    action_edit_label(){
        if(this.s_wiki.m_label.name.nyIsEmpty()){
            nyMessageToast.warning("请输入标签名称");
            return;
        }
        this.s_wiki.net_edit_label(this.action_list_data)
        this.dialog_close();
    }


    action_del_label(row){
        dzMsgBox.del("是否删除该信息？", () => {
            this.s_wiki.net_del_label(row.id,() => {
                this.action_list_data()
            });
        })
    }

    handleDbClick(row){
        if(row.id){
            this.handle_edit(row)
        }
    }

    handleSizeChange(val){
        this.m_page.pageSize = val
        this.action_list_data()
    }
}
